/* eslint-disable react/prop-types */
import {Modal, ModalTitle, ModalContent, Table, TableContainer, TableBody, TableCell, TableRow} from '@deere/fuel-react';
import {useDispatch, useSelector} from 'react-redux';
import {show} from '../../redux/features/modal/modal.slice';

export default function ModalCountryPhones() {
    const modals = useSelector((state) => state.modal.modals);
    const countryModal = Array.isArray(modals) ? modals.find((m) => m.name === 'countryModal') : {};
    const dispatch = useDispatch();
    const handleClose = (event) => {
        event.preventDefault();
        dispatch(show({
            name: 'countryModal',
            display: false
        }));
    };

    return (
        <Modal
            aria-describedby='alert-Modal-description1'
            aria-labelledby='alert-Modal-title1'
            onClose={handleClose}
            open={countryModal.display}
        >
            <ModalTitle
                divider
                id='alert-Modal-title1'
            >
                {'JDSN Support Phone Numbers'}
            </ModalTitle>
            <ModalContent>
                <TableContainer variant='elevated'>
                    <Table
                        aria-label='simple table'
                        size='small'
                        sx={{
                            minWidth: 500
                        }}
                    >
                        <TableBody>
                            <TableRow key={0}>
                                <TableCell align='left'>{'Other EMEA Countries'}</TableCell>
                                <TableCell align='left'>{'+49 621 829 4471 (English speaking)'}<br/>{'+49 621 829 4472 (French speaking)'}<br/>{'+49 621 829 4473 (German speaking)'}</TableCell>
                            </TableRow>
                            <TableRow key={2}>
                                <TableCell align='left'>{'Argentina'}</TableCell>
                                <TableCell align='left'>{'0800-444-6750'}</TableCell>
                            </TableRow>
                            <TableRow key={3}>
                                <TableCell align='left'>{'Australia'}</TableCell>
                                <TableCell align='left'>{'61-7-3802-3213 or ext 3213'}</TableCell>
                            </TableRow>
                            <TableRow key={4}>
                                <TableCell align='left'>{'Austria'}</TableCell>
                                <TableCell align='left'>{'0316918312'}</TableCell>
                            </TableRow>
                            <TableRow key={5}>
                                <TableCell align='left'>{'Belgium'}</TableCell>
                                <TableCell align='left'>{'024003417 (French)'}<br/>{'024003416 (English)'}</TableCell>
                            </TableRow>
                            <TableRow key={6}>
                                <TableCell align='left'>{'Brazil'}</TableCell>
                                <TableCell align='left'>{'0-8000-761-2010'}</TableCell>
                            </TableRow>
                            <TableRow key={7}>
                                <TableCell align='left'>{'Canada'}</TableCell>
                                <TableCell align='left'>{'1-866-458-0400'}</TableCell>
                            </TableRow>
                            <TableRow key={8}>
                                <TableCell align='left'>{'Chile'}</TableCell>
                                <TableCell align='left'>{'188-800-532-836'}</TableCell>
                            </TableRow>
                            <TableRow key={9}>
                                <TableCell align='left'>{'China'}</TableCell>
                                <TableCell align='left'>{'400-842-7115'}</TableCell>
                            </TableRow>
                            <TableRow key={10}>
                                <TableCell align='left'>{'Ecuador'}</TableCell>
                                <TableCell align='left'>{'+55-51-4042-1082'}</TableCell>
                            </TableRow>
                            <TableRow key={11}>
                                <TableCell align='left'>{'France'}</TableCell>
                                <TableCell align='left'>{'0170708197'}</TableCell>
                            </TableRow>
                            <TableRow key={12}>
                                <TableCell align='left'>{'Germany'}</TableCell>
                                <TableCell align='left'>{'0049 621 829 4473'}</TableCell>
                            </TableRow>
                            <TableRow key={13}>
                                <TableCell align='left'>{'India'}</TableCell>
                                <TableCell align='left'>{'000-800-001-6479'}</TableCell>
                            </TableRow>
                            <TableRow key={14}>
                                <TableCell align='left'>{'Ireland'}</TableCell>
                                <TableCell align='left'>{'0049 621 829 4471'}</TableCell>
                            </TableRow>
                            <TableRow key={15}>
                                <TableCell align='left'>{'Italy'}</TableCell>
                                <TableCell align='left'>{'+39 02 36003693'}</TableCell>
                            </TableRow>
                            <TableRow key={16}>
                                <TableCell align='left'>{'Mexico'}</TableCell>
                                <TableCell align='left'>{'01800-283-2915'}</TableCell>
                            </TableRow>
                            <TableRow key={17}>
                                <TableCell align='left'>{'Netherlands'}</TableCell>
                                <TableCell align='left'>{'0207132799'}</TableCell>
                            </TableRow>
                            <TableRow key={18}>
                                <TableCell align='left'>{'New Zealand'}</TableCell>
                                <TableCell align='left'>{'61-7-3802-3213 or ext 3213'}</TableCell>
                            </TableRow>
                            <TableRow key={19}>
                                <TableCell align='left'>{'Peru'}</TableCell>
                                <TableCell align='left'>{'0800-55-959'}</TableCell>
                            </TableRow>
                            <TableRow key={20}>
                                <TableCell align='left'>{'Poland'}</TableCell>
                                <TableCell align='left'>{'00800-491-1759'}</TableCell>
                            </TableRow>
                            <TableRow key={21}>
                                <TableCell align='left'>{'Russia'}</TableCell>
                                <TableCell align='left'>{'+7 495 783 4330 # 8888'}</TableCell>
                            </TableRow>
                            <TableRow key={22}>
                                <TableCell align='left'>{'Singapore'}</TableCell>
                                <TableCell align='left'>{'61-7-3802-3213 or ext 3213'}</TableCell>
                            </TableRow>
                            <TableRow key={23}>
                                <TableCell align='left'>{'South America Toll Number'}</TableCell>
                                <TableCell align='left'>{'+55-51-4042-1081 (Portuguese)'}</TableCell>
                            </TableRow>
                            <TableRow key={24}>
                                <TableCell align='left'>{'Spain'}</TableCell>
                                <TableCell align='left'>{'914140817'}</TableCell>
                            </TableRow>
                            <TableRow key={25}>
                                <TableCell align='left'>{'Sweden'}</TableCell>
                                <TableCell align='left'>{'(8) 5661-8415'}</TableCell>
                            </TableRow>
                            <TableRow key={26}>
                                <TableCell align='left'>{'Switzerland'}</TableCell>
                                <TableCell align='left'>{'0445803381 (French)'}<br/>{'0445803382 (German)'}</TableCell>
                            </TableRow>
                            <TableRow key={27}>
                                <TableCell align='left'>{'UK'}</TableCell>
                                <TableCell align='left'>{'01616018936'}</TableCell>
                            </TableRow>
                            <TableRow key={28}>
                                <TableCell align='left'>{'United States'}</TableCell>
                                <TableCell align='left'>{'1-866-458-0400'}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </ModalContent>
        </Modal>
    );
}
